var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42962",
    "data-name": "Group 42962",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15542",
    "data-name": "Rectangle 15542",
    width: 28,
    height: 28,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.773 1.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_42",
    d: "M69.044,75.106c-8.307.268-23.239-14.55-16.3-22.595l1.175-1.02a3.141,3.141,0,0,1,4.413.048c.03.03,1.92,2.487,1.92,2.487a3.163,3.163,0,0,1-.006,4.371l-1.061,1.264A1.412,1.412,0,0,0,59,61.188a13.012,13.012,0,0,0,5.838,5.85,1.391,1.391,0,0,0,1.527-.185l1.27-1.067A3.169,3.169,0,0,1,72,65.78s2.457,1.89,2.487,1.92a3.167,3.167,0,0,1,0,4.466l-.93,1.067A6.312,6.312,0,0,1,69.044,75.106Z",
    transform: "translate(-50.954 -50.61)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default __webpack_public_path__ + "static/media/phone-filled.e532e98af56c8c77efa61a088f14f868.svg";
export { ForwardRef as ReactComponent };